
import react,{ useState } from "react"
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Bottomstrip from "./Bottomstrip";
import './custome.css'
import Axios from "axios";
import thankyou from '../thankyou.png'
import { Fragment, useEffect } from 'react';

// import ReactDOM from 'react-dom';
import Fullscreen from 'react-full-screen';
import addressim from '../address.png';
import * as Icon from 'react-feather';
import { makeStyles } from '@material-ui/core/styles';

import Select from '@material-ui/core/Select';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import { Root, Preview, GlobalStyle } from '../styles';
import './style1.css';
import { Camera } from '../camera_bk';
import './style.scss';
import axios from 'axios';
import policememo from '../policememo.jpeg'

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'



const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    select: {
        '&:before': {
            borderColor: 'Gray',
        },
        color: 'Blue',
    },
    icon: {
        fill: 'Gray',
    },
}));

export default function PoliceMemo(){
    const agentNumber = localStorage.getItem("AgentNumber")

    const [isBkCameraOpen, setIsBkCameraOpen] = useState(false);
    const [cardImage, setCardImage] = useState();
    // const token = localStorage.getItem('token');
    const isselfiecomplete = localStorage.getItem("SelfieCompleted")
    const IssueType = localStorage.getItem("issueType")
    let tokenStr=localStorage.getItem('Token')
    if(localStorage.getItem('contingency')!=null &&localStorage.getItem('contingency')=='true' ){
        tokenStr="T"+tokenStr;
    }
    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);
    const classes = useStyles();
    
    let loggedin = true;
    if (tokenStr == null) {
        loggedin = false;
    }
    //localStorage.removeItem('kyc-photo');
    const docwhich = localStorage.getItem('whichdoc');
    if (docwhich) {
        console.log(docwhich);
    }

    const doc_f = localStorage.getItem('imgId7');

    const prmtpic = localStorage.getItem('imgId12');
    let photoclk = false;
    
    const [isFull, setIsFull] = useState(false);
    //  const who1 = JSON.parse(localStorage.getItem('data'));
    const [whichId, setWhichId] = useState(docwhich ? docwhich : '');
    function handleChange_close() {
        let source = localStorage.getItem("from");
        setIsBkCameraOpen(false);
        setCardImage(undefined);
        setIsFull(false);       
            // upload(doc_f);
    }

    function upload(){
        let addressapi=''
        const formData = new FormData();
        formData.append('image', prmtpic);
        formData.append('token', tokenStr);
        // if(UserType == "tourist"){
        //     addressapi='https://ekyc.chili.mu:9443/api/processVisa'
        // }
        // if(UserType == "resident"){
        //     addressapi='https://ekyc.chili.mu:9443/api/processPermit/permit'
        // }
        const req = axios.post(addressapi,formData, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        })
        .then(function (response) {
            photoclk = false;
            console.log('address',response.data.data);

        }
        ).catch(function(error){
            if (error.response) {
                console.log(error.response.data);
               const x =  error.response.status;
                console.log(error.response.headers);
                if(x==400){
                    alert(error.response.data.data)
              }             

            }
        });
    }

    useEffect(() => {
        localStorage.setItem('whichdoc', whichId);
    });
    
        return (
            <Fragment>
                {
                    agentNumber==null || agentNumber.trim().length==0?
                    null
                    :<div  style={{marginTop:-50,textAlign:'center', marginLeft:75}}>
                        <label><strong>Agent Number:{agentNumber}</strong></label>
                        <Link to="/logout" style={{textAlign:'end',marginLeft:20,color:'black'}}>Logout</Link>
                        <br></br>
                    </div>
                }

             
                {IssueType == "lost" ?
                <div style={{ textAlign: 'center' }}>
                <h5 style={{ textAlign: 'center', color: '#f049ac',marginLeft: 60,marginTop: 20,}}>                    
                    Upload Police Memo
                </h5>
            </div>
            :IssueType == "damage"?
            <div style={{ textAlign: 'center' }}>
                <h5 style={{ textAlign: 'center',color: '#f049ac', marginLeft: 80, marginTop: 20,}}>
                    Upload Picture of Damaged SIM with Application
                </h5>
               
            </div>
        :null
        }
                
               <br></br>
               <br></br>
               <br></br>
                <div className="selfie_page">
                    { (
                        <div className="id_logo">
                            <img
                                className="idcard"
                                src={policememo}
                                alt="address"
                                style={{ 
                                    marginTop: 55,
                                    marginLeft: 15,
                                }}
                            ></img>
                        </div>
                        )}
                        <div className="">
                        <Root>
                            <Fullscreen
                                enabled={isFull}
                                onChange={(isFull) => setIsFull(isFull)}
                            >
                                {isBkCameraOpen && isFull && (
                                    <Camera
                                        onCapture={(blob) => setCardImage(blob)}
                                        onClear={() => setCardImage(undefined)}
                                        changekaru={handleChange_close}
                                        
                                    />
                                    
                                )}
                                
                                {cardImage && (
                                    <div>
                                        <h2>Preview</h2>
                                        <Preview
                                            src={
                                                cardImage &&
                                                URL.createObjectURL(cardImage)
                                            }
                                        />
                                    </div>
                                )}
                            </Fullscreen>
                            <div className="camera-btn1">
                                <button
                                    className="button_id"
                                    onClick={() => {
                                        setIsBkCameraOpen(true);
                                        setIsFull(true);
                                        localStorage.setItem("from","memo")
                                    }}
                                    style={{
                                        marginLeft: 55,
                                        marginTop: 55,
                                        fontSize: 16,
                                        width: 120,
                                    }}
                                >
                                    Scan
                                </button>
                                
                                { 
                                  prmtpic ? (
                                    
                                    <Link
                                        to="/idproof"
                                        onClick={
                                             prmtpic
                                                ? null
                                                : (e) => e.preventDefault()
                                        }
                                    >
                                        <button
                                            className="button_id"
                                            style={{
                                                fontSize: 16,
                                                width: 120,
                                            }}
                                            disabled={
                                                  prmtpic
                                                    ? false
                                                    : true
                                            }
                                        >
                                            Proceed
                                        </button>
                                    </Link>
                                ) : null}
                                {/* <button
                                        className="button"
                                        onClick={() => {
                                            setIsBkCameraOpen(false);
                                            setCardImage(undefined);
                                            setIsFull(false);
                                        }}
                                    >
                                        Close Camera
                                    </button> */}
                            </div>
                        </Root>
                    <GlobalStyle />
                    </div>
                  
                    
                    <div className="header" style={{ textAlign: 'center', marginLeft: 150 }}>
                        <img
                            className="classid_f"
                            src={`data:image/jpeg;base64,${prmtpic}`}
                            height="150"
                            width="240"
                            alt="Front"
                        />
                        <br></br>
                        <br></br>                      
                    </div>
                    
                </div>
                
                <Bottomstrip/>
            </Fragment>
        )
    

    
}